export const TITLE = "Trip review";
export const SUBTITLE = "Review your trip before you Confirm and book.";
export const BACK_TO_RESULTS = "Back to results";
